export default {
  Title: 'Ghi sổ/ Bỏ ghi sổ theo lô',
  LabelInfo:
    'Chức năng này sẽ bỏ ghi sổ các chứng từ liên quan, thay thế số chứng từ cũ bằng số chứng từ mới và ghi sổ lại các chứng từ đó. Bạn nên sao lưu dữ liệu trước khi thực hiện chức năng này. ',
  InforPlus: 'Sao lưu dữ liệu',
  PeriodLabel: 'Khoảng thời gian',
  FromMonth: 'Từ tháng',
  Year: 'Năm',
  CheckBoxLabel: 'Ghi sổ các chứng từ chưa ghi sổ',
  Execute: 'Thực hiện',
  ConfirmMessage:
    'Hệ thống đã ghi sổ thành công {0} chứng từ, có {1} chứng từ ghi sổ không thành công. Bấm " Xem kết quả" để xem thêm.',
  ConfirmTitle: 'Hoàn thành bảo trì dữ liệu',
  Posted: {
    Title: 'Ghi sổ theo lô',
    Message: 'Tất cả các chứng từ đã được Ghi sổ.',
    Agree: 'Đồng ý',
    Close: 'Đóng',
    NoData: 'Dữ liệu chưa có chứng từ phát sinh: Vui lòng kiểm tra lại.',
  },
  UnPosted: {
    Title: 'Bỏ ghi sổ theo lô',
    Message: 'Tất cả các chứng từ đã được Bỏ ghi.',
    Close: 'Đóng',
    Agree: 'Đồng ý',
    NoData: 'Dữ liệu chưa có chứng từ phát sinh: Vui lòng kiểm tra lại.',
  },
  BackupData: 'Thông báo',
  InDeveloping: 'Tính năng đang phát triển!',
  PopupData: {
    BtnCancel: 'Hủy',
    BtnAgree: 'Đồng ý',
    Message: 'Bạn phải chọn ít nhất 1 phân hệ để thực hiện.',
    TitlePost: 'Ghi sổ không thành công',
    TitleUnPost: 'Bỏ ghi sổ không thành công',
  },
};
